import { Modal, Col, Row, Form } from 'react-bootstrap';
import { useContext, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { UserContext } from '../../../UserContext';
import { validateFormFields } from '../../../utils';
import { FormInput } from '../../../components/formElements/FormInput';
import CommonService from '../../../services/CommonService';
import CurrencyInput from '../../formElements/CurrencyInput';
import BaseService from '../../../services/BaseService';

const AddAdtrProceeds = (props) => {
    const user = useContext(UserContext);
    const { onModalClose, adtrs } = props;
    const [formErrors, setFormErrors] = useState({});
    const [fundCategoryTextError, setFundCategoryTextError] = useState("");
    const [otherFundCategoryNameError, setOtherFundCategoryNameError] = useState("");
    const [proceedsFundCategories, setProceedsFundCategories] = useState(null);
    const [showOtherField, setShowOtherField] = useState(false);

    const [stateValues, setStateValues] = useState({
        'fundCategoryText': '',
        'proceedAvlAmt': '',
        'otherFundCategory': ''
    })


    const handleChange = (e) => {
        const { name, value } = e.target;

        setStateValues(prevState => ({
            ...stateValues, [name]: value
        }));
        if (name === "fundCategoryText") {
            if (value === "Other") {
                setShowOtherField(true);
            } else {
                setShowOtherField(false);
            }
        }
    }


    useEffect(() => {
        async function getProceedsFundCategories() {
            const adtrId = adtrs[0]['adtrId'];
            var obj = {
                msgId: null,
                sysId: null,
                opr: "getProceedsFundCategories",
                hdrStruct: null,
                queryParam: null,
                reqData: { "adtrId": adtrId }
            };
            await BaseService.processRequest(obj)
                .then((result) => {
                    if (result.data.errors && result.data.errors.length > 0) {
                        toast.error(result.data.errors[0].message);
                    } else {
                        setProceedsFundCategories(result.data.responses[0])
                    }

                });
        }

        getProceedsFundCategories();
        // eslint-disable-next-line
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        const form = e.target.closest('form#add-adtr-proceeds');
        let formErrors = validateFormFields(form.elements);
        
        if (Object.keys(formErrors).length > 0) {
            setFormErrors(formErrors);
            return;
        }
        if (stateValues.fundCategoryText === ''){
            setFundCategoryTextError('This field is required');
            setOtherFundCategoryNameError('');
            setFormErrors({});
            return;
        }
        if (stateValues.fundCategoryText === 'Other' && stateValues.otherFundCategory === ''){
            setOtherFundCategoryNameError('This field is required');
            setFundCategoryTextError('');
            setFormErrors({});
            return;
        }
        
        setFormErrors({});
        setFundCategoryTextError('');
        setOtherFundCategoryNameError('');
        var obj = {
            msgId: null,
            sysId: null,
            opr: "addAdminAdtrProceeds",
            hdrStruct: null,
            queryParam: null,
            reqData: {
                "adtr": adtrs,
                "adtrProceed": {
                    "proceedAvlAmt": stateValues.proceedAvlAmt,
                    "fundCategoryText": stateValues.fundCategoryText !== "Other" ? stateValues.fundCategoryText : stateValues.otherFundCategory,
                    "createUser": CommonService.getUserName(user),
                    "lastUpdateUser": CommonService.getUserName(user)
                }
            },

        };

        BaseService.processRequest(obj)
            .then((result) => {
                if (result.data.errors && result.data.errors.length > 0) {
                    toast.error(result.data.errors[0].message);
                }
                else {
                    toast.success("ADTR Proceed added successfully!");
                    onModalClose();
                }

            });
        
    }


    return (
        <Modal show={true} backdrop="static" onHide={onModalClose}>
            <Modal.Header closeButton><h3>Add ADTR Funds</h3></Modal.Header>
            <Modal.Body>
                <form id="add-adtr-proceeds">
                    <div className="contactForm">
                        <Row>
                            <Col md={6} className="control">
                                <label><span className="required">*</span>Fund Category: </label>
                                <Form.Select as="select" name="fundCategoryText" onChange={(e) => handleChange(e)} value={stateValues.fundCategoryText} required={true}>
                                    <option value={""}>select</option>
                                    {proceedsFundCategories && proceedsFundCategories.map((item, i) => {
                                        return (<option key={i} value={item.FundCategoryDesc} >{item.FundCategoryDesc}</option>);
                                    }
                                    )}
                                </Form.Select>
                                <p className="error"> {fundCategoryTextError}</p>
                            </Col>
                            {showOtherField && <Col md={6}>
                                <FormInput label="Other Fund Category Name"
                                    name="otherFundCategory"
                                    type="text"
                                    value={stateValues.otherFundCategory}
                                    onChange={(e) => handleChange(e)}
                                />
                                <p className="error"> {otherFundCategoryNameError}</p>
                            </Col>}
                        </Row>
                        <Row>
                            <Col md={12} className="control">
                                <span className="required">* </span>
                                <CurrencyInput
                                    placeholder="0.00"
                                    label="Proceeds Available Amount"
                                    name="proceedAvlAmt"
                                    type="text"
                                    onChange={(e) => handleChange(e)}
                                    value={stateValues.proceedAvlAmt}
                                    validations={["required", "max:999999999999.99"]}
                                />
                                {formErrors['proceedAvlAmt'] && <span className="error">{formErrors['proceedAvlAmt']}</span>}

                            </Col>
                        </Row>
                    </div>
                    <div className="btn-div">
                        <div className="fright">
                            <button type="button" className="custom-button-secondary  btn-secondary" onClick={onModalClose}>Cancel</button>{" "}
                            <button className="custom-button" type="button" onClick={(e) => handleSubmit(e)}>Add ADTR Fund</button>
                        </div>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default AddAdtrProceeds
